import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@shared/models/interfaces/app-config';
import * as Sentry from '@sentry/angular';
import { excludeGraphQLFetch } from 'apollo-link-sentry';

// Called in main.ts before bootstrapping so errors during bootstrap are captured too
export const initSentry = (config: AppConfig): void => {
  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [Sentry.browserTracingIntegration({})],
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    beforeBreadcrumb: excludeGraphQLFetch,
    environment: config.environment,
    release: config.release,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: [config.apiUrl],
  });
};

@NgModule({
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    // The Angular browserTracingIntegration leaves navigation spans to the TraceService, which only works once created
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
})
export class SentryModule {}
